import React, { useState, useEffect } from 'react';
import useNetworkContext from './context';

const NetworkIndicator = () => {
  const { networkSpeedInMbps } = useNetworkContext();
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const getIndicatorStyles = () => {
    if (!isOnline) {
      return 'bg-red-5 text-white';
    }
    if (!networkSpeedInMbps || networkSpeedInMbps < 1) {
      return 'bg-red-5 text-white ';
    }
    if (networkSpeedInMbps < 2) {
      return 'bg-yellow-5 text-white';
    }
    return 'bg-green-5 text-white';
  };

  const getSpeedText = () => {
    if (!isOnline) {
      return 'Offline';
    }
    if (!networkSpeedInMbps) {
      return 'No Network';
    }
    return `${networkSpeedInMbps.toFixed(2)} Mbps`;
  };

  return (
    <div
      className={`
        inline-flex items-center px-2 py-1
        rounded-full border text-xs
        transition-all duration-300 ease-in-out
        font-medium shadow-sm hover:shadow
        cursor-default
        ${getIndicatorStyles()}
      `}>
      <div className='w-1.5 h-1.5 rounded-full mr-1.5 bg-current'></div>
      <span>{getSpeedText()}</span>
    </div>
  );
};

export default NetworkIndicator;
